import api from './api';

export interface Escola {
  id: number;
  nome: string;
  nif?: string;
  morada?: string;
  cidade: string;
  contacto?: string;
  email?: string;
  responsavel?: string;
  entity_id?: string;
  escola_admin_uid?: string;
  ativo: number;
  total_cantinas: number;
  total_pulseiras: number;
}

export interface Cantina {
  id: number;
  escola_id: number;
  nome: string;
  responsavel?: string;
  horario_abertura: string;
  horario_fecho: string;
  ativo: number;
}

export interface Pulseira {
  id: number;
  escola_id: number;
  cantina_id?: number;
  nfc_uid: string;
  aluno_nome: string;
  turma?: string;
  ano_letivo?: string;
  pai_uid?: string;
  pai_nome?: string;
  pai_telefone?: string;
  saldo: number;
  limite_diario: number;
  gasto_hoje: number;
  gasto_hoje_data?: string;
  status: 'ACTIVE' | 'INACTIVE' | 'BLOCKED';
  cantina_nome?: string;
}

export interface Transacao {
  id: number;
  tipo: 'TOPUP' | 'PURCHASE' | 'REFUND' | 'ADJUSTMENT';
  valor: number;
  saldo_antes?: number;
  saldo_depois?: number;
  descricao?: string;
  aluno_nome?: string;
  cantina_nome?: string;
  created_at: string;
}

export interface DashStats {
  total_alunos: number;
  saldo_total: number;
  pulseiras_ativas: number;
  pagamentos_hoje: number;
  receita_hoje: number;
  carregamentos_mes: number;
}

const cantinasService = {
  // ── Escolas ──
  async getEscolas(): Promise<Escola[]> {
    const r = await api.get('/admin/cantinas/schools');
    return r.data?.data || [];
  },
  async createEscola(data: Partial<Escola>): Promise<{ id: number }> {
    const r = await api.post('/admin/cantinas/schools', data);
    return r.data?.data;
  },
  async updateEscola(id: number, data: Partial<Escola>): Promise<void> {
    await api.put(`/admin/cantinas/schools/${id}`, data);
  },
  async deleteEscola(id: number): Promise<void> {
    await api.delete(`/admin/cantinas/schools/${id}`);
  },

  // ── Cantinas ──
  async getCantinas(escolaId: number): Promise<Cantina[]> {
    const r = await api.get(`/admin/cantinas/schools/${escolaId}/canteens`);
    return r.data?.data || [];
  },
  async createCantina(escolaId: number, data: Partial<Cantina>): Promise<void> {
    await api.post(`/admin/cantinas/schools/${escolaId}/canteens`, data);
  },
  async updateCantina(escolaId: number, id: number, data: Partial<Cantina>): Promise<void> {
    await api.put(`/admin/cantinas/schools/${escolaId}/canteens/${id}`, data);
  },

  // ── Pulseiras ──
  async getPulseiras(escolaId: number): Promise<Pulseira[]> {
    const r = await api.get(`/admin/cantinas/schools/${escolaId}/wristbands`);
    return r.data?.data || [];
  },

  // ── Transações ──
  async getTransacoes(escolaId: number, page = 1): Promise<{ data: Transacao[]; total: number }> {
    const r = await api.get(`/admin/cantinas/schools/${escolaId}/transactions?page=${page}&limit=50`);
    return { data: r.data?.data || [], total: r.data?.pagination?.total || 0 };
  },

  // ── Dashboard ──
  async getDashboard(escolaId: number): Promise<DashStats> {
    const r = await api.get(`/admin/cantinas/schools/${escolaId}/dashboard`);
    return r.data?.data || {};
  },
};

export default cantinasService;
